import { Component, forwardRef, StaticProvider } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { UserTitle, createUserTitleOptions } from "@main/users";
import { ControlBase } from "../control-base";

const TitleValueAccessor = <StaticProvider>{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TitleControlComponent),
    multi: true
};

@Component({
    selector: "m-title-control",
    template: `
        <p-dropdown
            [disabled]="disabled"
            [options]="titleOptions"
            [(ngModel)]="title"
            [showClear]="true"
            placeholder="Select title"
            (onBlur)="_onBlur()"
            (onChange)="onChange($event.value)">
        </p-dropdown>
    `,
    providers: [TitleValueAccessor]
})
export class TitleControlComponent extends ControlBase<UserTitle> {
    titleOptions = createUserTitleOptions();
    title: UserTitle;

    writeValue(obj: UserTitle): void {
        this.title = obj;
    }
}
